'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var noop = exports.noop = function noop() {};

var returnNull = exports.returnNull = function returnNull() {
  return null;
};

var returnTrue = exports.returnTrue = function returnTrue() {
  return true;
};

var getKey = exports.getKey = function getKey(item, index) {
  return item && typeof item.id !== 'undefined' ? item.id : index;
};

var isUndef = exports.isUndef = function isUndef(value) {
  return typeof value === 'undefined';
};

var isFunction = exports.isFunction = function isFunction(value) {
  return typeof value === 'function';
};

var isObject = exports.isObject = function isObject(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null && !Array.isArray(value);
};

var isValidPositiveNumberOrZero = exports.isValidPositiveNumberOrZero = function isValidPositiveNumberOrZero(num) {
  return Number.isFinite(num) && num >= 0;
};

var minMax = exports.minMax = function minMax(value, min, max) {
  if (value < min) return min;
  if (value > max) return max;
  return value;
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-core/dist/utils/misc.js
// module id = 97
// module chunks = 0